/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Resume_PracticeInputs */

const en_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Practice`)
};

const de_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung fortsetzen`)
};

const fr_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre l'exercice`)
};

const es_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanudar práctica`)
};

const it_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprendi esercitazione`)
};

const nl_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefening hervatten`)
};

const pl_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wznów ćwiczenie`)
};

const fi_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jatka harjoittelua`)
};

const da_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genoptag øvelse`)
};

const sv_interview_prepare_resume_practice = /** @type {(inputs: Interview_Prepare_Resume_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återuppta övning`)
};

/**
* | output |
* | --- |
* | "Resume Practice" |
*
* @param {Interview_Prepare_Resume_PracticeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_resume_practice = /** @type {((inputs?: Interview_Prepare_Resume_PracticeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Resume_PracticeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_resume_practice(inputs)
	if (locale === "fr") return fr_interview_prepare_resume_practice(inputs)
	if (locale === "es") return es_interview_prepare_resume_practice(inputs)
	if (locale === "it") return it_interview_prepare_resume_practice(inputs)
	if (locale === "nl") return nl_interview_prepare_resume_practice(inputs)
	if (locale === "pl") return pl_interview_prepare_resume_practice(inputs)
	if (locale === "fi") return fi_interview_prepare_resume_practice(inputs)
	if (locale === "da") return da_interview_prepare_resume_practice(inputs)
	if (locale === "sv") return sv_interview_prepare_resume_practice(inputs)
	return en_interview_prepare_resume_practice(inputs)
});